export enum AuthErrorsEnum {
  USER_IS_DISABLED = 'auth-001',
  USER_NOT_IN_ORGANIZATION = 'auth-002',
  INVALID_CREDENTIALS = 'auth-003',
  TOO_MANY_REQUESTS = 'auth-004',
  USER_SHOULD_RESET_PASSWORD = 'auth-005',
  INVALID_ACCESS_TOKEN = 'auth-006',
  INVALID_REFRESH_TOKEN = 'auth-007',
  INVALID_TWO_FACTOR_TOKEN = 'auth-008',
  REQUIRES_APPROVAL = 'auth-009',
  NOT_VERIFIED = 'auth-010',
  PHONE_NUMBER_IN_USE = 'auth-011',
  PHONE_NUMBER_NOT_VALID = 'auth-012',
  EMAIL_IN_USE = 'auth-013',
  INVALID_PHONE_VERIFICATION_CODE = 'auth-014',
  EMAIL_VERIFICATION_INVALID = 'auth-015',
  EMAIL_VERIFICATION_REQUEST_MISSING = 'auth-016',
  EMAIL_VERIFICATION_ORGANIZATION_REQUIRED = 'auth-017',
}
